import { getGiftCardAccessibilityDeclaration, InfoPageModel } from "api"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import KeyboardNavigation from "components/KeyboardNavigation/KeyboardNavigation"
import AccessibilityPage from "components/Texts/AccessibilityPage"
import { GetStaticProps } from "next"
import { useState } from "react"

type AccessibilityStaticProps = {
  data: InfoPageModel
  seo: SeoMetadataWithImage
}

export const getStaticProps: GetStaticProps<
  AccessibilityStaticProps
> = async () => {
  const { data } = await getGiftCardAccessibilityDeclaration()

  const seo = {
    title: data?.body?.pageTitle,
    description: data?.body?.metaDescription,
    keywords: data?.body?.keywords,
  }
  return {
    props: { data: data?.body, seo },
    revalidate: 60,
  }
}

const Accessibility = ({ data, seo }: AccessibilityStaticProps) => {
  const [refList, setRefList] = useState([])

  return (
    <>
      <KeyboardNavigation refList={refList} />
      <SeoMetaData data={seo} />
      <AccessibilityPage data={data} setRefList={setRefList} />
    </>
  )
}

export default Accessibility
